import PropTypes from 'prop-types';
import { Navigate, useSearchParams } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';
import Loader from 'ui-component/Loader';
import { sanitizeNextPath } from './authRedirect';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

export default function GuestGuard({ children }) {
  const { isInitialized, isLoggedIn } = useAuth();
  const [searchParams] = useSearchParams();

  if (!isInitialized) {
    return <Loader />;
  }

  if (isLoggedIn) {
    const nextPath = sanitizeNextPath(searchParams.get('next'));
    return <Navigate to={nextPath || DASHBOARD_PATH} replace />;
  }

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
